import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  stress_tests_result_article15: {
    name: "Results of the stress tests performed in accordance with point (b) under FUND 3.7.5 R, see also Article 15(3) of AIFMD: [risks associated with each investment position of the AIF and their overall effect on the AIF's portfolio can be properly identified, measured, managed, and monitored on an on-going basis, including through the use of appropriate stress testing procedures;]",
    order: 241,
    letter: 'A'
  },
  stress_tests_result_article16: {
    name: 'Results of the stress tests performed in accordance with FUND 3.6.3R, see also Article 16(1) of AIFMD: [AIFMs shall regularly conduct stress tests, under normal and exceptional liquidity conditions, which enable them to assess the liquidity risk of the AIFs and monitor the liquidity risk of the AIFs accordingly.]',
    order: 242,
    letter: 'A'
  }
};

export function ResultStressTest({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.RESULT_OF_STRESS_TESTS,
    onChangeFund,
    schema: schema.RESULT_OF_STRESS_TESTS,
    isStaticTemplate,
    requiredFields:
      funds[currentDataKey]?.required_tables?.RESULT_OF_STRESS_TESTS?.field_names || [],
    columnLables,
    isMultiFunds,
    funds,
    tableName: 'RESULT_OF_STRESS_TESTS'
  });

  return (
    <Table
      id="fca-reporttables-result-stress-test-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
